<template>
  <div :class="isLoading ? 'grayOut' : ''">
    <table>
        <tr>
          <th>&nbsp;</th>
          <th style="min-width:80px" v-for="key in ['Fuel Litres', 'PP', 'P@P %', /*'Fuel Dollars',*/ 'Cigs', 'ITCO', 'JTI', 'Roth', 'Vape', 'Pop', 'Conf', 'Oil', '# Sales', '$ Sales', 'Cash', 'Credit', 'Debit', 'Other']" :key="key">
            {{key}}
          </th>
        </tr>

        <tr v-for="location in $locations" :key="location">
          <td>{{location}}</td>
          <td align="right">
            {{data[location].fuel.litres | formatNumber}}
            ({{data[location].fuel.count}})
          </td>
          <!-- <td align="right">{{data[location].fuel.pap_litres | formatNumber}}</td> -->
          <td align="right">{{(data[location].fuelPrepay.dollars / data[location].fuel.dollars) | formatNumber('0.0%')}}</td>
          <td align="right">
            {{(data[location].fuel.pap_litres / data[location].fuel.litres) | formatNumber('0.0%')}}
            ({{data[location].fuel.pap_count}})
          </td>
          <!-- <td align="right">{{data[location].fuel.dollars | formatNumber}}</td> -->
          <td align="right">{{data[location].store.cigs_packs | formatNumber(',0')}}</td>
          <td align="right">{{data[location].distributors.imperial_packs | formatNumber(',0')}}</td>
          <td align="right">{{data[location].distributors.jti_packs | formatNumber(',0')}}</td>
          <td align="right">{{data[location].distributors.rothmans_packs | formatNumber(',0')}}</td>
          <td align="right">{{data[location].store.vape | formatNumber(',0')}}</td>
          <td align="right">{{data[location].store.pop | formatNumber(',0')}}</td>
          <td align="right">{{data[location].store.conf | formatNumber(',0')}}</td>
          <td align="right">{{data[location].store.oil | formatNumber(',0')}}</td>
          <td align="right">{{data[location].totalSales.sales_count | formatNumber(',0')}}</td>
          <td align="right">{{data[location].totalSales.sales_sum | formatNumber}}</td>
          <td align="right">{{data[location].totalSales.ca_sum | formatNumber}}</td>
          <td align="right">{{data[location].totalSales.cc_sum | formatNumber}}</td>
          <td align="right">{{data[location].totalSales.dc_sum | formatNumber}}</td>
          <td align="right">{{data[location].totalSales.ch_sum | formatNumber}}</td>
        </tr>
        <tr class="total">
          <td>Total</td>
          <td align="right">{{total.fuel.litres | formatNumber}}</td>
          <!-- <td align="right">{{total.fuel.dollars | formatNumber}}</td> -->
          <!-- <td align="right">{{total.fuel.pap_litres | formatNumber}}</td> -->
          <td align="right">{{(total.fuelPrepay.dollars / total.fuel.dollars) | formatNumber('0.0%')}}</td>
          <td align="right">
            {{(total.fuel.pap_litres / total.fuel.litres) | formatNumber('0.0%')}}
            ({{total.fuel.pap_count}}) 
          </td>
          <td align="right">{{total.store.cigs_packs | formatNumber(',0')}}</td>
          <td align="right">{{total.distributors.imperial_packs | formatNumber(',0')}}</td>
          <td align="right">{{total.distributors.jti_packs | formatNumber(',0')}}</td>
          <td align="right">{{total.distributors.rothmans_packs | formatNumber(',0')}}</td>
          <td align="right">{{total.store.vape | formatNumber(',0')}}</td>
          <td align="right">{{total.store.pop | formatNumber(',0')}}</td>
          <td align="right">{{total.store.conf | formatNumber(',0')}}</td>
          <td align="right">{{total.store.oil | formatNumber(',0')}}</td>
          <td align="right">{{total.totalSales.sales_count | formatNumber(',0')}}</td>
          <td align="right">{{total.totalSales.sales_sum | formatNumber}}</td>
          <td align="right">{{total.totalSales.ca_sum | formatNumber}}</td>
          <td align="right">{{total.totalSales.cc_sum | formatNumber}}</td>
          <td align="right">{{total.totalSales.dc_sum | formatNumber}}</td>
          <td align="right">{{total.totalSales.ch_sum | formatNumber}}</td>
        </tr>

        <tr>
          <td>&nbsp;</td>
          <td align="right">~PPU {{total.fuel.dollars / total.fuel.litres | formatNumber('0.000')}}</td>
          <!-- <td align="right">Total %</td> -->
          <td colspan="2" align="right">Total PP + P@P:{{(total.fuelPrepay.dollars / total.fuel.dollars) + (total.fuel.pap_litres / total.fuel.litres) | formatNumber('0.0%')}}</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td colspan="2" align="right">% Of Total:</td>
          
          <td align="right">{{(total.totalSales.ca_sum / total.totalSales.sales_sum) | formatNumber('0.0%')}}</td>
          <td align="right">{{(total.totalSales.cc_sum / total.totalSales.sales_sum) | formatNumber('0.0%')}}</td>
          <td align="right">{{(total.totalSales.dc_sum / total.totalSales.sales_sum) | formatNumber('0.0%')}}</td>
          <td align="right">{{(total.totalSales.ch_sum / total.totalSales.sales_sum) | formatNumber('0.0%')}}</td>
        </tr>
        
        <tr v-if="compareTo && compareTo.RCGB">
          <td>Diff</td>
          <td align="right" :class="diffColor(diff.fuel.litres)">            {{diff.fuel.litres| formatNumber}}</td>
          <!-- <td align="right" :class="diffColor(diff.fuel.dollars)">           {{diff.fuel.dollars | formatNumber}}</td> -->
          <!-- <td align="right" :class="diffColor(diff.fuel.pap_litres / diff.fuel.litres)">            {{diff.fuel.pap_litres / diff.fuel.litres| formatNumber('0.0%')}}</td> -->
          <!-- <td align="right" :class="diffColor(diff.fuel.pap_litres)">            {{diff.fuel.pap_litres| formatNumber}}</td> -->
          <td align="right" ></td>
          <td align="right" ></td>
          <td align="right" :class="diffColor(diff.store.cigs_packs )">      {{diff.store.cigs_packs | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.distributors.imperial_packs )">      {{diff.distributors.imperial_packs | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.distributors.jti_packs )">      {{diff.distributors.jti_packs | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.distributors.rothmans_packs )">      {{diff.distributors.rothmans_packs | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.store.vape)">              {{diff.store.vape | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.store.pop)">               {{diff.store.pop | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.store.conf)">              {{diff.store.conf | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.store.oil)">               {{diff.store.oil  | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.totalSales.sales_count)">  {{diff.totalSales.sales_count | formatNumber('0,0')}}</td>
          <td align="right" :class="diffColor(diff.totalSales.sales_sum)">    {{diff.totalSales.sales_sum | formatNumber}}</td>
          <td align="right" :class="diffColor(diff.totalSales.ca_sum)">       {{diff.totalSales.ca_sum | formatNumber}}</td>
          <td align="right" :class="diffColor(diff.totalSales.cc)">           {{diff.totalSales.cc_sum | formatNumber}}</td>
          <td align="right" :class="diffColor(diff.totalSales.dc_sum)">       {{diff.totalSales.dc_sum | formatNumber}}</td>
          <td align="right" :class="diffColor(diff.totalSales.ch_sum)">       {{diff.totalSales.ch_sum | formatNumber}}</td>
        </tr>
        <tr v-if="compareTo && compareTo.RCGB">
          <td>%</td>
          <td align="right" :class="diffColor(percentDiff.fuel.litres)">             {{percentDiff.fuel.litres| formatNumber('0.0%')}}</td>
          <!-- <td align="right" :class="diffColor(percentDiff.fuel.dollars)">            {{percentDiff.fuel.dollars | formatNumber('0.0%')}}</td> -->
          <!-- <td align="right" :class="diffColor(percentDiff.fuel.pap_litres / percentDiff.fuel.litres)">             {{percentDiff.fuel.pap_litres / percentDiff.fuel.litres | formatNumber('0.0%')}}</td> -->
          <!-- <td align="right" :class="diffColor(percentDiff.fuel.pap_litres)">             {{percentDiff.fuel.pap_litres| formatNumber('0.0%')}}</td> -->
          <td align="right" ></td>
          <td align="right" ></td>
          <td align="right" :class="diffColor(percentDiff.store.cigs_packs )">       {{percentDiff.store.cigs_packs | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.distributors.imperial_packs )">       {{percentDiff.distributors.imperial_packs | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.distributors.jti_packs )">       {{percentDiff.distributors.jti_packs | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.distributors.rothmans_packs )">       {{percentDiff.distributors.rothmans_packs | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.store.vape )">       {{percentDiff.store.vape | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.store.pop)">               {{percentDiff.store.pop | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.store.conf)">              {{percentDiff.store.conf | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.store.oil)">              {{percentDiff.store.oil | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.sales_count)">  {{percentDiff.totalSales.sales_count | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.sales_sum)">    {{percentDiff.totalSales.sales_sum | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.ca_sum)">    {{percentDiff.totalSales.ca_sum | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.cc_sum)">    {{percentDiff.totalSales.cc_sum | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.dc_sum)">    {{percentDiff.totalSales.dc_sum | formatNumber('0.0%')}}</td>
          <td align="right" :class="diffColor(percentDiff.totalSales.ch_sum)">    {{percentDiff.totalSales.ch_sum | formatNumber('0.0%')}}</td>
        </tr>
      </table>
      <div v-if="isLoading" style="color:black !important">
        Loading...
      </div>
      <div v-else>
        <br>
      </div>
  </div>  
</template>

<script>
const f = v => numeral(v).value()
import _ from 'lodash'
export default {
  name: 'LocationSummaryTable',
  props : ['value', 'timestamps', 'compareTo'],
  data () { return {
      previousTimestamps: {
        from: undefined,
        to: undefined,
      },
      data: {
        RCGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        RMGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        WGB : {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
      },
      compareToData : {
        RCGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        RMGB: {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
        WGB : {isLoading: false, fuel:{}, fuelPrepay:{}, store:{}, totalSales:{}},
      },
    }
  },
  created : function(){
    // this._loadData();
    this.loadData();
  },
  watch: {
    'timestamps.from' : 'loadData',
    'timestamps.to' : 'loadData',
    'compareTo' : function(val){
      console.log('compareTo', val)
      this.compareToData = val
    }
  },
  computed : {
    total: function(){
      // console.log('sumSubSubKeys', this.data)
      return this.$math.sumSubSubKeys(this.data, true)
    },
    compareToTotal: function(){
      return this.$math.sumSubSubKeys(this.compareTo, true)
    },
    diff: function(){
      return this.$math.diffSubKeys(this.total, this.compareToTotal)
    },
    percentDiff: function(){
      return this.$math.percentDiffSubKeys(this.total, this.compareToTotal)
    },
    isLoading: function(){
      let result = false;
      this.$locations.forEach(location => {
        const l = this.data[location]
        const c = this.compareToData[location]
        result = result || l.fuel.isLoading || l.store.isLoading || l.totalSales.isLoading || l.fuelPrepay.isLoading
        result = result || c.fuel.isLoading || c.store.isLoading || c.totalSales.isLoading || c.fuelPrepay.isLoading
      })
      return result;
    }
  },
  methods: {
    _loadData: _.debounce(function(){
      this._loadData()
    }, 800),
    loadData: function(){
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(this.timestamps.from).format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(this.timestamps.to).format("YYYY-MM-DD HH:mm:ss");
      //Skip if from and to are the same
      if(from === to){
        console.log('skipping')
        return
      }

      
      
      console.log('from to', from, to)
      // console.log('original from to', this.timestamps.from.toDate(), this.timestamps.to.toDate())

      // this.rcgbFuel = this.rmgbFuel = this.wgbFuel = {};
      
      this.$locations.forEach(location=>{
        const getData = (endpoint, dataKey) => {
          this.data[location][dataKey] = {}
          this.data[location][dataKey].isLoading = true;
          this.$axios.post(endpoint, { location, from, to }).then((r)=>{
            this.data[location][dataKey].isLoading = false;
            this.data[location][dataKey] = r.data.length > 0 ? r.data[0] : this.data[location][dataKey]
            this.$emit('input', this.data)
          });
        }

        getData('/getFuelSalesSummary', 'fuel')
        getData('/getFuelPrepaySalesSummary', 'fuelPrepay')
        getData('/getStoreSalesSummary', 'store')
        getData('/getStoreTotalSales', 'totalSales')
        getData('/getDistributorSalesSummary', 'distributors')
      })
    },
    diffColor: function(num){
      return f(num) > 0 ? 'green' : 'red'
    }
  },
  filters: {
    formatNumber: function(num, formatStyle="0,000.00"){
      return numeral(num === undefined ? 0 : num).format(formatStyle);
    },
    
  }
}
</script>

<style scoped>
  .total td {
    font-weight: bold;
  }
  .green {
    color: darkgreen;
  }
  .red {
    color: darkred;
  }
  .grayOut * {
    color: darkgray !important;
  }
  table {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
</style>
